import React from 'react';
import { Link } from 'react-router-dom';
import { Button, TextField, Paper } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function ProfileScreen() {
  return (
    <ScreenFrame
      title="Profile"
      actions={<Button component={Link} to="/prototype/dashboard" variant="outlined" size="small">Dashboard</Button>}
    >
      <Paper sx={{ p: 2, maxWidth: 400 }}>
        <TextField fullWidth label="Name" margin="normal" defaultValue="Demo User" />
        <TextField fullWidth label="Email" margin="normal" defaultValue="demo@example.com" />
        <Button variant="contained" sx={{ mt: 2 }}>Save profile</Button>
      </Paper>
      <Button component={Link} to="/prototype/help" variant="outlined" sx={{ mt: 2 }}>Help</Button>
    </ScreenFrame>
  );
}
